export default {
  hasPoaInterest(state) {
    return state.interests.some((interest) => interest.product === 'POA');
  },
};
